module.exports = __webpack_public_path__ + "static/blog57-82a6dcabec33b718c6eb802d5e386545.png";